<template>
  <div
    v-if="contentCaiVan !== ''"
    class="row"
    v-html="contentCaiVan"/>
</template>

<script>
  import {errorToaster} from '../../services/ErrorHandler'
  import ApiConfig from '../../communicate/ApiConfig'
  import rf from '../../communicate/RequestFactory'

  export default {
    name: "CaiVanContent",
    data () {
      return {
        id: this.$route.params.id,
        base_url: ApiConfig.base_url,
        contentCaiVan: ''
      }
    },

    mounted () {
      this.getLasoContent(this.id);
    },
    methods: {
      getLasoContent (id) {
        this.$Progress.start();
        rf.getRequest("ServiceRequest").getCaiVanContent(id).then((res) => {
          this.contentCaiVan = res;
          this.$Progress.finish();
        }).catch(err => {
          errorToaster("Cố vấn phong thủy", "Xảy ra lỗi kết nối");
          this.$Progress.fail();
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/history/CaiVanContent.vue